module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei4.svg";